import { render, staticRenderFns } from "./NotYetView.vue?vue&type=template&id=841b9c90&"
import script from "./NotYetView.vue?vue&type=script&lang=ts&"
export * from "./NotYetView.vue?vue&type=script&lang=ts&"
import style0 from "./NotYetView.vue?vue&type=style&index=0&id=841b9c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports